export const isEmpty = (obj) => {
  if (!obj || Object.keys(obj).length === 0) {
    return true;
  }
  return false;
};
